import ExcelJS from 'exceljs/dist/es5/exceljs.browser.js'
import { saveAs } from 'file-saver'
import logoINE from '../../../assets/img/INE_logo_black.png'
import logoMat from '../../../assets/img/ID_docs_black.png'
import moment  from 'moment'

//Estilos generales
const fuenteTitulo = {
  name: "Arial",
  size: 14,
  bold: true,
  //color: { argb: '0000000' },
};  

const fuenteDatos = {
  name:"Arial",
  size: 10
}

const estiloGris = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "000000" },
  bgColor: { argb: "ffffff" },
};

const estiloGrisFont = {
  bold: true,
  color: { argb: 'fffffff' }
}


const dateTime = new Date();
const fechaHora = {
    fecha:moment(dateTime).format("DD/MM/YYYY"), 
    hora:moment(dateTime).format("HH:mm:ss") }
let entidad = "";

export async function descargaExcel(sheetName, nombreReporte, nombreClasificacion, datos, isReporte) {
  entidad = localStorage.getItem('ESTADO');
  //Creación del workbook
  const wb = new ExcelJS.Workbook()
  wb.created = new Date();
  //Creación de nueva hoja
  const sheet = wb.addWorksheet(sheetName);
  // Se agregan las imagenes
  const imageLogoIne = wb.addImage({
    base64: logoINE,
    extension: 'png',
  });
  const imageLogoMat = wb.addImage({
    base64: logoMat,
    extension: 'png',
  });
  sheet.addImage(imageLogoIne,{
    ext: { width: 120, height: 40 }
  });
  sheet.addImage(imageLogoMat,{
    tl: { col: 4.9, row: 0 },
    ext: { width: 150, height: 40 }
  });
  sheet.getRow(1).height = 40
  sheet.mergeCells("A1:F1");
  sheet.getCell("A1").font = fuenteTitulo;
  sheet.getCell("A1").alignment = { horizontal: "center"};
  sheet.getRow(2).height = 40
  sheet.mergeCells("A2:F2");
  sheet.getCell("A2").font = fuenteTitulo;
  sheet.getCell("A2").alignment = { horizontal: "center"};
  sheet.getCell("A2").value = 'Reporte de estatus de la notificación';
  let fila;
  sheet.getRow(3).height = 25
  sheet.mergeCells("A3:B3");
  sheet.getCell("A3").alignment = { horizontal: "center"};
  sheet.getCell("A3").value = (entidad && entidad != "null")? `Entidad: ${entidad}`: 'Entidad: OFICINAS CENTRALES';
  sheet.getCell("C3").alignment = { horizontal: "center"};
  sheet.getCell("C3").value = `Clasificación: ${nombreClasificacion}`;
  sheet.mergeCells("D3:F3");
  sheet.getCell("D3").alignment = { horizontal: "center"};
  sheet.getCell("D3").value = `Fecha: ${fechaHora.fecha}`;
  //const rowFechaGeneracion = sheet.getRow(4);
  
  //Titulo de los datos del reporte
  const rowTituloDatos = sheet.getRow(4);
  rowTituloDatos.height = 42;
  rowTituloDatos.values = (entidad && entidad != "null") 
  ? !isReporte
    ? ["No.", "Documento/Material", "Tipo de Eleción", "Observaciones", "Emblema", "Estatus notificación"]
    : ["No.", "Tipo de clasificación", "Documento/Material", "Tipo de Eleción", "Observaciones", "Emblema", "Estatus notificación"]
  : !isReporte
    ? ["No.", "Entidad", "Documento/Material", "Tipo de Eleción", "Observaciones", "Emblema", "Estatus notificación"]
    : ["No.", "Entidad", "Tipo de clasificación", "Documento/Material", "Tipo de Eleción", "Observaciones", "Emblema", "Estatus notificación"];
  rowTituloDatos.font = estiloGrisFont;
  rowTituloDatos.eachCell(function(cell) {
    cell.fill = estiloGris;
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  });
  //Datos del reporte
  fila = 5;
  datos.forEach((e, index) => {
    const rowDatos = sheet.getRow(fila);
    rowDatos.font = fuenteDatos;
    rowDatos.values = (entidad && entidad != "null") 
      ? !isReporte
        ? [index + 1, e.nombre, e.nombreTipoEleccion, e.conObservaciones, e.conEmblema, e.estatusNotif]
        : [index + 1, e.tipoClasificacion, e.nombre, e.nombreTipoEleccion, e.conObservaciones, e.conEmblema, e.estatusNotif]
      : !isReporte
        ? [index + 1, e.entidad, e.nombre, e.nombreTipoEleccion, e.conObservaciones, e.conEmblema, e.estatusNotif]
        : [index + 1, e.entidad, e.tipoClasificacion, e.nombre, e.nombreTipoEleccion, e.conObservaciones, e.conEmblema, e.estatusNotif];
    fila++;
  });
  sheet.getColumn(1).width = 10;
  sheet.getColumn(2).width = 40;
  sheet.getColumn(3).width = 45;
  sheet.getColumn(4).width = 15;
  sheet.getColumn(5).width = 15;
  sheet.getColumn(6).width = 15;
  //Creación del excel
  const buf = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buf]), nombreReporte + ".xlsx");
}